import { CheckboxField } from '@calendly/form';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { IconInfoSquareRounded } from '@calendly/ui/components/glyphs/IconInfoSquareRounded';
import { Link } from '@calendly/ui/components/link';
import { ProTip } from '@calendly/ui/components/pro-tip';
import { LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { UrlField } from 'components/event_type_edit';
import { useErrorAfterInitialTouch } from 'features/event_type_editor';
const externalSectionCss = "e12kbjn4";
const redirectFieldCss = "r9m679s";
const redirectLabelCss = "r14icjl1";
const learnMoreLinkCss = "l1y5h3uh";
const RedirectField = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(redirectFieldCss, props.className)} />;
});
const PassBookingDetailsLabel = () => <>
    {I18n.t('publisher.event_types.confirmation_page.info.pass_booking_details')}
    {' '}
    <Link className={learnMoreLinkCss} href="https://calendly.com/help/how-to-redirect-invitees-to-another-site-after-booking" rel="noopener noreferrer" target="_blank" underline={false}>
      {I18n.t('publisher.action.learn_more')}
    </Link>
  </>;
export const ExternalSection = () => {
  const urlFieldName = 'redirectConfigurationUrl';
  useErrorAfterInitialTouch(urlFieldName);
  return <div className={externalSectionCss} data-testid="confirmation-external-section">
      <RedirectField>
        <div className={redirectLabelCss}>
          <LabelText>
            {I18n.t('publisher.event_types.confirmation_page.labels.redirect_url')}
          </LabelText>
          <ProTip glyphIcon={IconInfoSquareRounded} size="small">
            {HtmlParser(I18n.t('publisher.event_types.confirmation_page.labels.redirect_url_tip'))}
          </ProTip>
        </div>
        <UrlField autoFocus aria-label={I18n.t('publisher.event_types.confirmation_page.labels.redirect_url')} name={urlFieldName} placeholder="https://www.example.com" />
      </RedirectField>
      <CheckboxField label={<PassBookingDetailsLabel />} name="redirectConfiguration.passBookingDetails" />
    </div>;
};

require("./external_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./external_section.js");